import { Result } from "../../models/result";

export function sortPriceAscending(a: Result, b: Result) {
	if (a === undefined || b === undefined) {
		return 0;
	}

	if (a.prices[0] < b.prices[0]) {
		return -1;
	}
	if (a.prices[0] > b.prices[0]) {
		return 1;
	}

	return 0;
}
